module.exports = __webpack_public_path__ + "c5b032c1858de85099dd7129a0c35b05.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/components/sp-group-name/sp-group-name.html
// module id = 1009
// module chunks = 0